import { useMelioIntl } from '@melio/platform-i18n';

export const usePlanInfo = ({ planId }: { planId?: string }) => {
  const { formatMessage } = useMelioIntl();

  if (planId === '1') {
    return {
      planName: formatMessage('activities.subscription.plans.1.title'),
      featuresTitle: formatMessage('activities.subscription.plans.features.1.title'),
      featuresList: [
        formatMessage('activities.subscription.plans.features.1.member'),
        formatMessage('activities.subscription.plans.features.1.quickbooksXero'),
        formatMessage('activities.subscription.plans.features.1.vendorManagement'),
        formatMessage('activities.subscription.plans.features.1.basicWorkflows'),
        formatMessage('activities.subscription.plans.features.1.melioBillInbox'),
      ],
    };
  }

  if (planId === '2') {
    return {
      planName: formatMessage('activities.subscription.plans.2.title'),
      featuresTitle: formatMessage('activities.subscription.plans.features.2.title'),
      featuresList: [
        formatMessage('activities.subscription.plans.features.2.unlimitedMembers'),
        formatMessage('activities.subscription.plans.features.2.approvalFlows'),
        formatMessage('activities.subscription.plans.features.2.VendorStorage'),
        formatMessage('activities.subscription.plans.features.2.advanceAccountingSync'),
        formatMessage('activities.subscription.plans.features.2.batchPayments'),
        formatMessage('activities.subscription.plans.features.2.advancedUserRoles'),
        formatMessage('activities.subscription.plans.features.2.overallLowerFees'),
      ],
    };
  }

  if (planId === '3') {
    return {
      planName: formatMessage('activities.subscription.plans.3.title'),
      featuresTitle: formatMessage('activities.subscription.plans.features.3.title'),
      featuresList: [
        formatMessage('activities.subscription.plans.features.3.multipleWorkspaces'),
        formatMessage('activities.subscription.plans.features.3.customFeesRates'),
        formatMessage('activities.subscription.plans.features.3.prioritySupport'),
      ],
    };
  }

  return {
    planName: '',
    featuresTitle: '',
    featuresList: [],
  };
};
